/**
 *
 * VideoPlayerControls
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import IconHolder from 'components/Icons/IconHolder';

import FulscreenOff from 'assets/video_player/videoplayer_fullscreenoff.svg';
import FulscreenOn from 'assets/video_player/videoplayer_fullscreenon.svg';
import Mute from 'assets/video_player/videoplayer_soundoff.svg';
import Play from 'assets/video_player/videoplayer_play.svg';
import Pause from 'assets/video_player/videoplayer_pause.svg';
import Unmute from 'assets/video_player/videoplayer_soundon.svg';
import Picture from 'assets/icons/switchview_desktop.svg';

import VideoPlayerProgress from '../VideoPlayerProgress';
import Volume from '../Volume';

import VideoPlayerButton from './styles/VideoPlayerButton';
import VideoPlayerControlsContainer from './styles/VideoPlayerControlsContainer';
import VideoPlayerButtonsGroup from './styles/VideoPlayerButtonsGroup';
import VideoPlayerControlsBottomWrapper from './styles/VideoPlayerControlsBottomWrapper';
import VideoPlayerControlsMiddle from './styles/VideoPlayerControlsMiddle';
import VideoPlayerControlsWrapper from './styles/VideoPlayerControlsWrapper';
import VideoPlayerControlsMute from './styles/VideoPlayerControlsMute';
import VideoPlayerControlsLive from './styles/VideoPlayerControlsLive';

class VideoPlayerControls extends React.PureComponent {
  constructor() {
    super();

    this.toggleMute = this.toggleMute.bind(this);
    this.togglePlay = this.togglePlay.bind(this);
  }

  togglePlay() {
    const { onPause, onPlay, paused } = this.props;

    if (paused) {
      onPlay();
    } else {
      onPause();
    }
  }

  toggleMute() {
    const { onVolumeChange, volume } = this.props;

    if (volume) {
      onVolumeChange(0);
    } else {
      onVolumeChange(1);
    }
  }

  render() {
    const {
      controls,
      currentTime,
      duration,
      isFullscreen,
      isLive,
      onFullscreenChange,
      onChangeProgress,
      onVolumeChange,
      paused,
      visible,
      volume,
      handlePictureInPicture
    } = this.props;

    const isMuted = !volume;

    if (controls) {
      return (
        <>
          <VideoPlayerControlsWrapper>
            <VideoPlayerControlsMiddle  visible={visible || paused}>
              <VideoPlayerButton
                isLarge={true}
                name={paused ? 'play' : 'pause'}
                paused={paused}
                onClick={this.togglePlay}
              >
                <IconHolder icon={paused ? Play : Pause} />
              </VideoPlayerButton>
            </VideoPlayerControlsMiddle>
            <VideoPlayerControlsBottomWrapper  visible={visible && currentTime > 0 || visible && !paused}>
              {isLive ? <VideoPlayerControlsLive>Live</VideoPlayerControlsLive> : (
                <VideoPlayerProgress
                  currentTime={currentTime}
                  duration={duration}
                  isLive={isLive}
                  onChangeProgress={onChangeProgress}
                />
              )}
              <VideoPlayerControlsContainer>
                <VideoPlayerButtonsGroup>
                  <VideoPlayerButton
                    name={paused ? 'play' : 'pause'}
                    onClick={this.togglePlay}
                    thisStyles={
                      {
                        marginRight: '2rem !important'
                      }
                    }
                  >
                    <IconHolder icon={paused ? Play : Pause} />
                  </VideoPlayerButton>
                  <VideoPlayerButton
                    name={isMuted ? 'unmute' : 'mute'}
                    onClick={this.toggleMute}
                  >
                    <IconHolder icon={isMuted ? Mute : Unmute} />
                  </VideoPlayerButton>
                  <Volume volume={volume} onVolumeChange={onVolumeChange} />
                </VideoPlayerButtonsGroup>
                <VideoPlayerButtonsGroup>
                  <VideoPlayerButton
                    name={isFullscreen ? 'fulscreenOff' : 'fulscreenOn'}
                    onClick={onFullscreenChange}
                  >
                    <IconHolder icon={isFullscreen ? FulscreenOff : FulscreenOn} />
                  </VideoPlayerButton>
                  <VideoPlayerButton
                    name={isFullscreen ? 'fulscreenOff' : 'fulscreenOn'}
                    onClick={handlePictureInPicture}
                  >
                    <IconHolder icon={Picture} />
                  </VideoPlayerButton>
                </VideoPlayerButtonsGroup>
              </VideoPlayerControlsContainer>
            </VideoPlayerControlsBottomWrapper>
          </VideoPlayerControlsWrapper>
          {
            isMuted ? (
              <VideoPlayerControlsMute>
                <VideoPlayerButton
                  name={isMuted ? 'unmute' : 'mute'}
                  onClick={this.toggleMute}
                >
                  <IconHolder icon={isMuted ? Mute : Unmute} />
                </VideoPlayerButton>
              </VideoPlayerControlsMute>
            ) : ''
          }
  
        </>
      );
    }

    return '';
  }
}

VideoPlayerControls.propTypes = {
  isPlaying: PropTypes.bool,
  onVolumeChange: PropTypes.func
};

export default VideoPlayerControls;
